import { render, staticRenderFns } from "./TraidComments.vue?vue&type=template&id=178e50b5"
import script from "./TraidComments.vue?vue&type=script&lang=js"
export * from "./TraidComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports